export default {
  title: 'Google-yritys',
  sections: {
    google_business_info: 'Google-yritystiedot',
    google_reviews: 'Google-arvostelut',
    settings: 'Asetukset',
    danger_zone: 'Vaara-alue',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Tekoälyn automaattiset vastaukset',
    },
    reviews_autopilot_daily_limit: {
      label: 'Tekoälyn automaattisten vastausten päiväraja (väh. 1, enint. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Tuntien määrä, jonka pitää kulua arvostelun kirjoittamisesta',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Näytä kaikki arvostelut',
      show_only_unanswered: 'Näytä vain vastaamattomat',
    },
    rating_filter: {
      label: 'Arvosanasuodatin',
      stars_one: '{{count}} tähti',
      stars_other: '{{count}} tähteä',
    },
    sorting: {
      newest_to_oldest: 'Lajittele uusimmasta vanhimpaan',
      oldest_to_newest: 'Lajittele vanhimmasta uusimpaan',
      rating_highest_to_lowest: 'Lajittele arvosanan mukaan korkeimmasta alimpaan',
      rating_lowest_to_highest: 'Lajittele arvosanan mukaan alimmasta korkeimpaan',
    },
  },
  table: {
    pagination: {
      total_one: 'Yhteensä {{count}} arvostelu',
      total_other: 'Yhteensä {{count}} arvostelua',
    },
  },
  modal_publish: {
    title: 'Haluatko varmasti julkaista Googleen?',
    buttons: {
      yes: 'Kyllä',
      cancel: 'Peruuta',
    },
  },
  popconfirm: {
    title: 'Oletko varma?',
    description: 'Kaikki paikalliset muutokset korvataan',
  },
  disconnect_profile: {
    title: 'Katkaise profiilin yhteys',
    button: 'Jatka',
    popconfirm: {
      title: 'Oletko varma?',
      description:
        'Tämä katkaisee tämän Google-profiilin yhteyden FoodAmigos-järjestelmään kokonaan, mukaan lukien automaattinen linkkien korvaaminen ja arvostelujen automaattivastaukset!',
    },
  },
  buttons: {
    login_with_google: 'Kirjaudu Googlella',
    sync_from_google: 'Hae uusin versio',
    publish_to_google: 'Julkaise Googleen',
    previous: 'Edellinen',
    next: 'Seuraava',
    save_settings: 'Tallenna asetukset',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    failed_to_fetch_reviews: 'Arvostelujen hakeminen epäonnistui',
    failed_to_fetch_settings: 'Asetusten hakeminen epäonnistui',
    failed_to_load_google_business: 'Google-yrityksen lataaminen epäonnistui',
    failed_to_publish_to_google_business: 'Julkaiseminen Google-yritykseen epäonnistui',
    publish_access_denied:
      'Google hylkäsi päivityksen: yhdistetty Google-tili ei voi enää muokata tätä yritysprofiilia. Tarkista käyttöoikeudet Google Business Profilessa tai yhdistä uudelleen tilillä, joka hallinnoi ravintolaa.',
    failed_to_fetch_info: 'Google-yrityksen uusimman version hakeminen epäonnistui',
    success_publish_to_google_business: 'Julkaistiin onnistuneesti Google-yritykseen',
    success_sync_from_google: 'Synkronoitu onnistuneesti Google-yrityksestä',
    success_save_settings: 'Asetukset tallennettu onnistuneesti',
    failed_to_disconnect_profile:
      'Google-yrityksen yhteyden katkaiseminen epäonnistui, ota yhteyttä tekniseen tiimiin!',
    popup_blocked: 'Salli ponnahdusikkunat tälle sivustolle yhdistääksesi Google-yrityksen.',
    failed_to_connect: 'Google-yritystä ei voitu yhdistää. Yritä uudelleen.',
    no_business_profile:
      'Tämä Google-tili ei hallinnoi yritysprofiilia. Kirjaudu sisään tilillä, joka hallinnoi ravintolaa.',
  },
  callback: {
    connecting: 'Yhdistetään Google-yritystä…',
    connected: 'Google-yritys on yhdistetty. Tämän ikkunan voi sulkea.',
    cancelled: 'Kirjautuminen peruutettiin. Tämän ikkunan voi sulkea.',
    failed: 'Google-yritystä ei voitu yhdistää. Sulje tämä ikkuna ja yritä uudelleen.',
  },
  alerts: {
    no_profile: {
      title: 'Ei yhdistettyä Google-paikkaa',
      description: 'Yhdistä ravintola Google-paikkaan.',
      button: {
        connect: 'Yhdistä',
      },
    },
    unverified_location: {
      title: 'Google-yritystä ei ole vahvistettu',
      description: 'Vahvista Google-yrityksesi jatkaaksesi',
    },
  },
};
